// extracted by mini-css-extract-plugin
export default {"popup":"coordinatesPopup_popup__ylY3u"};